/**
 * Флаги функций, временно скрытых из интерфейса. Код за флагом сохраняется —
 * чтобы вернуть функцию, достаточно переключить флаг в true.
 */

/** Блок «Панорама» (готовый 2D-снимок) на странице обследования. Построение,
 *  подгонка дуги, файл в списке снимков и панорама во вьювере остаются. */
export const EXAM_PANORAMA_BLOCK_ENABLED = false;
